var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "form__field-holder",
        {
          "form__field-holder_error": !!_vm.errors.has(_vm.newName),
          "radio-btn-item": _vm.extraStylingIsEnabled
        }
      ],
      attrs: {
        "data-vv-value-path": "model",
        "data-vv-as": _vm.label ? _vm.label : _vm.validationLabel
      }
    },
    [
      _c(
        "div",
        { staticClass: "form__field-box" },
        [
          _vm.label
            ? _c("label", { staticClass: "form__label" }, [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.rules,
                expression: "rules"
              }
            ],
            attrs: { type: "hidden", name: _vm.name },
            domProps: { value: _vm.model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.model = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.sort
            ? [
                _c(
                  "div",
                  {
                    class: [
                      "v-checkbox",
                      {
                        "v-checkbox--is-dirty": _vm.isDirty,
                        "v-checkbox--is-disabled": _vm.disabled,
                        "v-checkbox--has-label":
                          Object.keys(_vm.options).length || this.$slots.default
                      }
                    ]
                  },
                  _vm._l(
                    _vm.sortProperties(_vm.options, _vm.sortBy, _vm.order),
                    function(option, key) {
                      return _c(
                        "label",
                        {
                          key: option[0],
                          staticClass:
                            "v-checkbox__item v-checkbox__item--is-radio",
                          attrs: { for: _vm.name + key },
                          on: { click: _vm.stateChange }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model,
                                expression: "model"
                              }
                            ],
                            attrs: {
                              name: _vm.name,
                              type: "radio",
                              disabled: _vm.disabled,
                              id: _vm.name + option[0]
                            },
                            domProps: {
                              value: option[0],
                              checked: _vm._q(_vm.model, option[0])
                            },
                            on: {
                              change: [
                                function($event) {
                                  _vm.model = option[0]
                                },
                                function($event) {
                                  _vm.$emit("input", _vm.model),
                                    _vm.$emit("change", _vm.model)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "v-checkbox__indicator" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(option[1]) }
                          })
                        ]
                      )
                    }
                  ),
                  0
                )
              ]
            : _c(
                "div",
                {
                  class: [
                    "v-checkbox",
                    {
                      "v-checkbox--is-dirty": _vm.isDirty,
                      "v-checkbox--is-disabled": _vm.disabled,
                      "v-checkbox--has-label":
                        Object.keys(_vm.options).length || this.$slots.default
                    }
                  ]
                },
                _vm._l(_vm.options, function(option, key) {
                  return _c(
                    "label",
                    {
                      key: key,
                      staticClass:
                        "v-checkbox__item v-checkbox__item--is-radio",
                      attrs: { for: _vm.name + key },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.disableAutoComplete()
                          _vm.stateChange($event)
                        }
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model,
                            expression: "model"
                          }
                        ],
                        attrs: {
                          name: _vm.name,
                          type: "radio",
                          disabled: _vm.disabled,
                          id: _vm.name + key
                        },
                        domProps: {
                          value: key,
                          checked: _vm._q(_vm.model, key)
                        },
                        on: {
                          change: function($event) {
                            _vm.model = key
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "v-checkbox__indicator" }),
                      _vm._v(" "),
                      _c("span", { domProps: { innerHTML: _vm._s(option) } })
                    ]
                  )
                }),
                0
              )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dce265c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dce265c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VRadiosPublic.vue
// module id = 432
// module chunks = 1